import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import React from 'react';

import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';

// this component is used to check if the user wants to switch to active for orders
// if an order is activated/deactivated, all children line items will also be activated/deactivated
export interface IProps extends IWithStylesProps {
  // opens the modal
  active: boolean;
  toActivateNames: string;
  toDeactivateNames: string;
  handleCancel?: () => void;
  handleAccept?: () => void;
}

export const ModelDialogMultiActive = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IProps> {
    render() {
      const { active, toActivateNames, toDeactivateNames } = this.props;
      return (
        <Grid>
          <Dialog
            open={active}
            onClose={this.props.handleCancel}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>
              Deactivated publishers are disabled in Headerbidding and the UI until reactivated.
            </DialogTitle>
            {!!toActivateNames.length && (
              <Grid>
                <DialogTitle>Activate the following publishers:</DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {toActivateNames}
                  </DialogContentText>
                </DialogContent>
              </Grid>
            )}
            {!!toDeactivateNames.length && (
              <Grid>
                <DialogTitle>Deactivate the following publishers:</DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {toDeactivateNames}
                  </DialogContentText>
                </DialogContent>
              </Grid>
            )}
            <DialogActions>
              <Button onClick={this.props.handleCancel} color='primary' autoFocus>
                Cancel
              </Button>
              <Button onClick={this.props.handleAccept}>Accept</Button>
            </DialogActions>
          </Dialog>
        </Grid>
      );
    }
  },
);
